import ConfigureStore from './configureStore';
export default ConfigureStore();